export enum RoleEnum {
	ADMIN = 'admin',
	USER = 'user',
}
